import { Header } from "../../../../src/components/common/header";
import { Footer } from "../../../../src/components/common/footer";
import { PrivacyPolicyCompanies } from "../../../../src/components/privacy-policy-companies/index";
import * as React from 'react';
export default {
  Header,
  Footer,
  PrivacyPolicyCompanies,
  React
};